// @ts-strict-ignore
import { CommonModule } from "@angular/common";
import { Component, OnInit } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { InputTextModule } from "primeng/inputtext";
import { TableModule } from "primeng/table";
import * as C from "../../../../../../shared/constants/globals.constants";
import { EWizDynamicBaseClassComponent } from "src/app/modules/esim/shared/classes/ewiz-dynamic.class";
import { GuidanceBoxComponent } from "src/app/modules/esim/shared/components/guidance-box/guidance-box.component";
import { ErrorMessageComponent } from "src/app/modules/esim/shared/components/error-message/error-message.component";

@Component({
  selector: C.EWIZ_NETWORK_NAME_CONFIGURATION,
  templateUrl: "./network-name-configuration.component.html",
  standalone: true,
  imports: [CommonModule, FormsModule, InputTextModule, TableModule, GuidanceBoxComponent, ErrorMessageComponent]
})
export class EWizNetworkNameConfigurationComponent extends EWizDynamicBaseClassComponent implements OnInit {
  ngOnInit() {
    this.profileValues.networkNameVisited = true;
    this.handleFormEvents();
  }
}
